/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { ContentZone } from "cms/components/layout/index";
import { FieldDisplayWrapper } from "cms/fields/layout/field-display-wrapper";
import { Logger } from "cms/utils/log/logger";

const ComponentFieldDisplay = () => {
    
    const onChangeInDisplay = () => {
        Logger.debug("onChangeInDisplay - unexpected");
    };
    
    return (
        <FieldDisplayWrapper>
            <ContentZone
                onChange={onChangeInDisplay}
            />
        </FieldDisplayWrapper>
    );
};
ComponentFieldDisplay.displayName = "ComponentFieldDisplay";
export { ComponentFieldDisplay };
